import { HttpService } from 'app/services';
import { sortBy } from 'lodash';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';
import {
  MENU,
  JOB_MANAGERMENT_ENUM,
  USER_MANAGEMENT_ENUM,
  PHARMACY_MANAGEMENT_ENUM,
  DIRECTIONS_MANAGEMENT_ENUM,
  PATIENT_GROUP_MANAGEMENT_ENUM,
  DOCTOR_MANAGEMENT_ENUM,
  REPORT_MANAGEMENT_ENUM,
  DISPENSE_TRACKER_MANAGEMENT_ENUM,
  VPB_MANAGEMENT_ENUM,
  DRUG_MANAGEMENT_ENUM,
  PATIENT_MANAGEMENT_ENUM,
  ROLE_MANAGEMENT_ENUM,
  PRINT_OPTIONS_MANAGEMENT_ENUM,
  ADMINISTRATOR_ID,
} from '../../constants';

export const GET_ROLE = '@ROLE/GET_ROLE_DETAILS';
export const GET_ROLE_SUCCESS = '@ROLE/GET_ROLE_SUCCESS';
export const GET_ROLE_FAIL = '@ROLE/GET_ROLE_FAIL';

export const UPDATE_ROLE = '@ROLE/UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = '@ROLE/UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAIL = '@ROLE/UPDATE_ROLE_FAIL';

export const CHANGE_ROLE_UPDATE_FORM = '@ROLE/CHANGE_ROLE_UPDATE_FORM';

export const CLEAR_UPDATE_FORM = '@ROLE/CLEAR_UPDATE_FORM';

export function getRoleDetails(roleId, callback) {
  return (dispatch) => {
    dispatch({ type: GET_ROLE });
    HttpService.get(`api/roles/${roleId}`)
      .then((resp) => {
        const permissions = resp.data.permissions
          .filter((permission) => MENU.some((menu) => menu.key === permission?.menuCode))
          .map((permission) => ({
            ...permission,
            displayName: MENU.find((menu) => menu.key === permission?.menuCode)?.label,
            entryPermissions: permission?.entryPermissions.map((entry) => {
              const jobPermission = JOB_MANAGERMENT_ENUM.find((menu) => menu.key === entry.code);
              const userPermission = USER_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const pharmacyPermission = PHARMACY_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const directionsPermission = DIRECTIONS_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const patientGroupPermission = PATIENT_GROUP_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const doctorPermission = DOCTOR_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const reportPermission = REPORT_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const dispensTrackerPermission = DISPENSE_TRACKER_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const vpbPermission = VPB_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const drugPermission = DRUG_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const patientPermission = PATIENT_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const rolePermission = ROLE_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const printOptionsPermission = PRINT_OPTIONS_MANAGEMENT_ENUM.find((menu) => menu.key === entry.code);
              const permissionData =
                jobPermission ||
                userPermission ||
                pharmacyPermission ||
                directionsPermission ||
                patientGroupPermission ||
                doctorPermission ||
                reportPermission ||
                dispensTrackerPermission ||
                vpbPermission ||
                drugPermission ||
                patientPermission ||
                rolePermission ||
                printOptionsPermission;
              return {
                ...entry,
                displayEntryName: permissionData?.label,
                group: permissionData?.group,
                order: permissionData?.order,
                isAllowed:
                  roleId === ADMINISTRATOR_ID && entry.code === 'patientCommentsForChangeOfMedicationRequired'
                    ? false
                    : entry.isAllowed,
              };
            }),
            menuOrder: MENU.find((menu) => menu.key === permission?.menuCode)?.order,
          }));
        const orderedPermissions = sortBy(permissions, 'menuOrder');
        dispatch({ type: GET_ROLE_SUCCESS, payload: { data: { ...resp.data, permissions: orderedPermissions } } });
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({
          type: GET_ROLE_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages, { callback }));
      });
  };
}

export function updateRole(roleData) {
  return (dispatch, getState) => {
    const { id } = getState().role.update;
    const permissions = roleData.permissions.map((i) => {
      return {
        entryPermissions: [...i.entryPermissions],
        isAccessible: i.isAccessible,
        menuCode: i.menuCode,
      };
    });
    const postData = {
      name: roleData.name,
      permissions,
      isChangeCommentRequired: roleData.isChangeCommentRequired,
    };

    dispatch({ type: UPDATE_ROLE });

    return HttpService.put(`api/roles/${id}`, postData)
      .then(() => {
        dispatch({ type: UPDATE_ROLE_SUCCESS });
        return Promise.resolve();
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({
          type: UPDATE_ROLE_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
}

export function clearUpdateForm() {
  return (dispatch) => {
    dispatch({ type: CLEAR_UPDATE_FORM });
  };
}

export function changeRoleUpdateForm(data) {
  return (dispatch) => {
    dispatch({ type: CHANGE_ROLE_UPDATE_FORM, payload: { data } });
  };
}
